<template>
  <div class="module-top">
    <span>{{ topText }}</span>
    <img :src="require('@/assets/footer_logo.png')" alt="中国品牌日">
  </div>
</template>

<script>
export default {
  name: "moduleTop",
  props:{
    topText:{
      type: String,
      default:''
    }
  },
  data() {
    return {

    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.module-top {
  width: 100%;
  height: 109px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: $bgColor-2;
  padding: 0 45px;
  font-size: 32px;
  color: #fff;
  font-weight: bold;
  & > img {
    display: block;
    width: 160px;
  }
}
</style>
